// src/features/eventos/components/Section.jsx
import styles from "../../styles/eventos.module.css";

export const Section = ({ title, aside, children }) => (
    <section className={styles.section}>
        <div className={styles.head}>
            <h3>{title}</h3>
            {aside}
        </div>
        <div className={styles.stack}>{children}</div>
    </section>
);
